/***************************************************************************/
"use client";
/***************************************************************************/

import React from "react";
import ConnectionContext from "./connection-context";
import { TConnectionConfig, TOnAfterFetch, TOnBeforeFetch } from "./types";

/**
 * Provides connection-related configurations and lifecycle hooks via context.
 * This component wraps parts of the application that need access to
 * connection settings and request lifecycle hooks.
 */
const ConnectionProvider: React.FC<{
  /** Child components that will have access to the connection context. */
  children: React.ReactNode;
  /** Base URL for API requests. */
  rootUrl: string;
  /** Optional connection configuration. */
  config?: TConnectionConfig;
  /** Optional headers to be included in requests. */
  headers?: HeadersInit;
  /** Hook executed before a fetch request is initiated. */
  onBefore?: TOnBeforeFetch;
  /** Hook executed after a fetch request is completed. */
  onAfter?: TOnAfterFetch;
}> = ({ children, rootUrl, config, headers, onBefore, onAfter }) => {
  return (
    <ConnectionContext.Provider
      value={{
        rootUrl,
        config,
        headers,
        onBefore,
        onAfter,
      }}
    >
      {children}
    </ConnectionContext.Provider>
  );
};

export default ConnectionProvider;
